import { Send } from 'lucide-react'
import { MentionAutocomplete } from '@/components/ui/mention-autocomplete'
import { Tag } from '../../state/types'

interface ChatInputProps {
  value: string
  onChange: (value: string) => void
  onKeyPress: (e: React.KeyboardEvent) => void
  onMentionAdd: (mention: Tag) => void
  onMentionRemove: (id: string) => void
  onSend: () => void
  disabled: boolean
  placeholder: string
}

export function ChatInput({
  value,
  onChange,
  onKeyPress,
  onMentionAdd,
  onMentionRemove,
  onSend,
  disabled,
  placeholder
}: ChatInputProps) {
  const canSend = value.trim() && !disabled

  return (
    <div className="bg-card p-6 pb-0">
      <div className="relative">
        <MentionAutocomplete
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          onMentionAdd={onMentionAdd}
          onMentionRemove={onMentionRemove}
          placeholder={placeholder}
          rows={3}
          disabled={disabled}
          className="w-full pr-12 py-3 pl-4 text-sm"
        />
        <button
          onClick={onSend}
          disabled={!canSend}
          className="absolute right-2 bottom-2 p-2 bg-primary hover:bg-primary/90 disabled:bg-muted disabled:text-muted-foreground text-primary-foreground rounded-lg transition-colors"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
} 